import {
    SAVE_ALL_UI,
    SET_LAUNCH_DELAY,
    SET_AUTO_LAUNCH_ON_LOGIN,
    SET_AUTO_LAUNCH_ON_STARTUP,
    SET_LAYOUT,
    SET_UI_AS_LOADED,
} from './constants'

export function markAsLoaded() {
    return { type: SET_UI_AS_LOADED }
}

export function saveUiSettings(uiSettings) {
    return {
        type: SAVE_ALL_UI,
        payload: uiSettings,
    }
}

export function setLaunchDelay(delay) {
    return {
        type: SET_LAUNCH_DELAY,
        payload: delay,
    }
}

export function setAutoLaunchOnLogin(autoLaunch) {
    return {
        type: SET_AUTO_LAUNCH_ON_LOGIN,
        payload: autoLaunch,
    }
}

export function setAutoLaunchOnStartup(autoLaunch) {
    return {
        type: SET_AUTO_LAUNCH_ON_STARTUP,
        payload: autoLaunch,
    }
}

export function setLayout(layout) {
    return {
        type: SET_LAYOUT,
        payload: layout,
    }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/ui/actions.js